module.exports = __webpack_public_path__ + "img/computer4@2x.7631d167.png";